<template>
    <ValidationObserver tag="form" ref="observer" @submit.prevent="submit()">
        <FormInput :label="$t('formularios.n_abonado', { abonado: teatro.texto_abonado })" :name="$t('formularios.n_abonado', { abonado: teatro.texto_abonado })" type="number" v-model="localData.n_abonado" rules="required" />
        <FormInput :label="$t('partidos.lfp_4_cifras')" :name="$t('partidos.lfp_4_cifras')" type="number" v-model="localData.pin" rules="required|max:4|min:4" />
        <div class="alert alert-danger d-flex align-items-center justify-content-between mt-3 p-1" v-if="error">
            <div class="pl-2">
                <b v-if="error === 'The given data was invalid.'">{{ $t('perfil.datos_no_validos') }}</b>
                <b v-else>{{ error?.message }}</b>
            </div>
        </div>

        <div class="row">
            <div class="col-12 d-flex justify-content-between">
                <button type="submit" class="button" name="button" :disabled="loading">{{ $t('formularios.enviar') }}</button>
            </div>
        </div>
    </ValidationObserver>
</template>

<script>
    export default {
        props: ['error', 'loading', 'data'],
        data() {
            return {
                localData: { 
                    id_persona: this.data.id_persona || '',
                    pin: this.data.pin || ''
                }
            }
        },
        computed: {
            teatro() {
                return this.$store.getters.getTeatro;
            }
        },
        methods: {
            async submit() {
                const isValid = await this.$refs.observer.validate();
                if (isValid) {
                    this.buscarAbono();
                }
            },
            buscarAbono() {
                this.$emit('buscarAbonado', this.localData);
            }
        }
    }
</script>